export const testId = {
    button: 'button',
    buttonText: 'buttonText'
};